import { Helmet, HelmetProvider } from 'react-helmet-async';
import { FaDollarSign, FaCalendarCheck, FaMoneyCheckAlt, FaChartLine, FaChartPie, FaWallet, FaShieldAlt } from 'react-icons/fa';
import "./divida.css";
import ImgGrafico from "../../assets/money-2724241_1920.jpg"; // Importe a imagem do gráfico
import ImgEstatisticas from "../../assets/girl-7625566_1920.jpg"; // Importe a imagem das estatísticas

function Divida() {
    return (
        <HelmetProvider>
            <div className="container-debt">

                <Helmet>
                    <meta name="description" content="Descubra como sair das dívidas e recuperar seu equilíbrio financeiro com 7 passos estratégicos. Dicas práticas para eliminar suas dívidas e alcançar a liberdade financeira." />
                    <meta name="keywords" content="dívidas, finanças, liberdade financeira, planejamento financeiro, orçamento, negociação de dívidas" />
                    <meta name="author" content="Felipe de Quadros Gomes" />
                    <meta property="og:title" content="Como Sair das Dívidas: 7 Passos Estratégicos para Recuperar seu Equilíbrio Financeiro" />
                    <meta property="og:description" content="Descubra como sair das dívidas e recuperar seu equilíbrio financeiro com 7 passos estratégicos. Dicas práticas para eliminar suas dívidas e alcançar a liberdade financeira." />
                    <meta property="og:url" content="https://guiafinanceiro.vercel.app/divida" />
                    <meta property="og:type" content="article" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Como Sair das Dívidas: 7 Passos Estratégicos para Recuperar seu Equilíbrio Financeiro" />
                    <meta name="twitter:description" content="Descubra como sair das dívidas e recuperar seu equilíbrio financeiro com 7 passos estratégicos. Dicas práticas para eliminar suas dívidas e alcançar a liberdade financeira." />
                    <title>Como Sair das Dívidas: 7 Passos Estratégicos para Recuperar seu Equilíbrio Financeiro</title>
                    <link rel="canonical" href="https://guiafinanceiro.vercel.app/divida" />
                </Helmet>

                <main className="main-debt">
                    <article>
                        <header className="header-debt">
                            <h1>Como Sair das Dívidas: 7 Passos Estratégicos para Recuperar seu Equilíbrio Financeiro</h1>
                        </header>
                  
                        <section className="section-debt">
                            <h2>Sua Jornada para a Liberdade Financeira Começa Aqui</h2>
                            <p>Estar endividado não é o fim, é apenas o começo de uma nova história financeira.
                                Embora as dívidas possam parecer esmagadoras,
                                com uma abordagem estratégica, você pode recuperar seu equilíbrio financeiro e construir um futuro mais estável. Este guia oferece um caminho claro e prático para sair das dívidas e alcançar a liberdade financeira.</p>
                            <img
                                alt="Gráfico de Motivos das Dívidas"
                                className="img-debt"
                                src={ImgGrafico}
                            />
                        </section>

                        <section className="section-debt">
                            <h2>Por que as Dívidas Acontecem?</h2>
                            <p>Antes de abordar as soluções, é importante entender as causas das dívidas. Algumas das razões mais comuns incluem:</p>
                            <ul>
                                <li><strong>Falta de planejamento financeiro:</strong>Sem um plano financeiro sólido, é fácil gastar mais do que se ganha.</li>
                                <li><strong>Gastos impulsivos:</strong>Compras por impulso podem rapidamente acumular dívidas.</li>
                                <li><strong>Emergências não previstas:</strong>Despesas inesperadas, como contas médicas ou reparos de veículos, podem levar ao endividamento.</li>
                                <li><strong>Descontrole no uso de cartão de crédito:</strong>O uso irresponsável do cartão de crédito pode resultar em altas dívidas devido aos juros.</li>
                            </ul>
                        </section>

                        <section className="section-debt">
                            <h2>7 Passos Práticos para Eliminar Suas Dívidas</h2>

                            <article>
                                <h3><FaDollarSign className="icon-debt" /> 1. Faça um Diagnóstico Financeiro Honesto</h3>
                                <p>O primeiro passo é encarar a realidade. Liste:</p>
                                <ul>
                                    <li><strong>Todas as dívidas:</strong>Inclua empréstimos, cartões de crédito e qualquer outra dívida.</li>
                                    <li><strong>Valores exatos:</strong>Anote quanto você deve em cada dívida.</li>
                                    <li><strong>taxa de juros:</strong>Se possível, registre as taxas de juros de cada dívida.</li>
                                    <li><strong>Prazos de pagamentos:</strong>Note os prazos de vencimento.</li>
                                    <li><strong>Anote em um papel ou bloco de notas:</strong>Ter uma visão clara da sua situação financeira é crucial.</li>
                                </ul>
                            </article>

                            <article>
                                <h3><FaCalendarCheck className="icon-debt" /> 2. Crie um Orçamento Realista</h3>
                                <ul>
                                    <li><strong>Registre cada entrada e saída:</strong>Anote todas as suas fontes de renda e despesas.</li>
                                    <li><strong>Corte gastos supérfluos:</strong>Identifique despesas que podem ser reduzidas ou eliminadas, como assinaturas de serviços não essenciais e gastos com alimentação fora de casa.</li>
                                    <li><strong>Crie uma planilha de controle:</strong>Use uma planilha para monitorar seus gastos e garantir que está seguindo o orçamento.</li>
                                    <li><strong>Priorize as despesas essenciais:</strong>Como aluguel, luz, água e alimentação.</li>
                                    <li><strong>Pague-se depois:</strong>Considere investir o que sobrar em um CDB ou outro tipo de investimento.</li>
                                    <li><strong>Use o restante para despesas variáveis:</strong>Como lazer e compras esporádicas.</li>
                                </ul>
                            </article>

                            <article>
                                <h3><FaMoneyCheckAlt className="icon-debt" /> 3. Estratégia de Pagamento: Bola de Neve ou Avalanche?</h3>
                                <p>Escolher a estratégia certa pode acelerar sua jornada para a liberdade financeira.</p>
                                <ol>
                                    <li><strong>Método Bola de Neve:</strong>Concentre-se em pagar as menores dívidas primeiro. Isso proporciona um senso de realização e motivação para continuar.</li>
                                    <li><strong>Método Avalanche:</strong>Foque nas dívidas com maiores juros. Isso pode economizar mais dinheiro a longo prazo, pois você reduzirá os custos com juros.</li>
                                </ol>
                            </article>

                            <article>
                                <h3><FaChartLine className="icon-debt" /> 4. Negocie Suas Dívidas</h3>
                                <p>Negociar com seus credores pode resultar em condições mais favoráveis para o pagamento das dívidas.</p>
                                <div className="div-debt">
                                    <img
                                        alt="mulher preocupada com boleto"
                                        className="img-debt"
                                        src={ImgEstatisticas}
                                    />
                                </div>
                                <ul>
                                    <li><strong>Entre em contato com credores:</strong>Explique sua situação financeira e peça condições de pagamento mais favoráveis.</li>
                                    <li><strong>Peça redução de juros:</strong>Muitas vezes, os credores estão dispostos a reduzir as taxas de juros para facilitar o pagamento.</li>
                                    <li><strong>Proponha parcelamentos:</strong>Solicite opções de parcelamento que sejam viáveis para seu orçamento.</li>
                                    <li><strong>Mantenha uma comunicação respeitosa:</strong>A boa comunicação pode facilitar acordos.</li>
                                    <li><strong>Verifique o Serasa:</strong>Verifique oportunidades de descontos em feirões como o "Feirão Limpa Nome".</li>
                                </ul>
                            </article>

                            <article>
                                <h3><FaChartPie className="icon-debt" /> 5. Aumente Sua Renda</h3>
                                <p>Explorar novas fontes de renda pode acelerar o pagamento das dívidas.</p>
                                <ul>
                                    <li><strong>Faça freelas:</strong>Use plataformas como GetNinjas, Workana e 99Freelas para encontrar trabalhos freelances.</li>
                                    <li><strong>Venda itens não utilizados:</strong>Venda coisas que você não usa mais para gerar dinheiro extra.</li>
                                    <li><strong>Busque promoção no trabalho:</strong>Trabalhe em melhorar seu desempenho e buscar oportunidades de promoção.</li>
                                    <li><strong>Aprenda novas habilidades:</strong>Invista em cursos gratuitos ou pagos que possam aumentar suas qualificações e oportunidades de emprego.</li>
                                    <li><strong>Leia livros:</strong>Leia bastante, aumente seus conhecimetos, seu vocabulario , aprenta a se expressar.</li>
                                </ul>
                            </article>

                            <article>
                                <h3><FaWallet className="icon-debt" /> 6. Evite Novos Empréstimos</h3>
                                <p>Evitar novas dívidas é crucial para não agravar a situação financeira.</p>
                                <ul>
                                    <li><strong>Cartão de crédito</strong>Use com cautela e evite acumular mais dívidas.</li>
                                    <li><strong>Empréstimos consignados</strong>Evite a tentação de pegar novos empréstimos, pois eles podem comprometer seu orçamento ainda mais.</li>
                                    <li><strong>Financiamentos sem necessidade</strong>Pense bem antes de assumir novos financiamentos.</li>
                                </ul>
                            </article>

                            <article>
                                <h3><FaShieldAlt className="icon-debt" /> 7. Construa uma Reserva de Emergência</h3>
                                <span>Ter uma reserva financeira é essencial para lidar com imprevistos sem recorrer a dívidas.</span>
                                <p><strong>Objetivo:</strong> Acumule o equivalente a 3-6 meses de despesas em uma conta de fácil acesso.</p>
                            </article>
                        </section>

                        <section className="cta-debt">
                            <h3>Sua Mudança Começa Agora</h3>
                            <p>Sair das dívidas não é sorte, é estratégia. Com disciplina e conhecimento, você conquista sua independência financeira. A jornada pode ser desafiadora, mas cada passo dado é um passo mais próximo da liberdade financeira.</p>

                        </section>
                    </article>
                </main>
            </div>
        </HelmetProvider>
    );
}

export default Divida;

